import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

const TransactionCardSummary = ({
  title,
  response,
  transactionType,
  isAiraloTransactionType,
  handleViewDetails,
  canViewDetails,
}) => (
  <Grid item size={{ xs: 12 }}>
    <Grid container direction='column' className='device-info'>
      <Grid item>
        <Typography variant='h6' color='#FF6347'>
          <span style={{ color: '#7A3C92' }}>{title}</span>
        </Typography>
      </Grid>
      <Grid item>
        <Grid
          container
          justifyContent='space-between'
          alignItems='center'
          spacing={2}
          style={{ lineHeight: '6' }}
        >
          <Grid item>
            <Typography variant='body1' color='#FF6347' style={{ lineHeight: '1.6' }}>
              <strong>Concepto de pago: </strong>
              {isAiraloTransactionType
                ? response?.transaction_type?.payment_concept || 'N/A'
                : response?.payment_provider === null
                  ? 'N/A'
                  : transactionType}
            </Typography>
            {isAiraloTransactionType ? (
              <Typography variant='body1' color='#FF6347' style={{ lineHeight: '2' }}>
                <strong>Flujo:</strong>
                <strong style={{ marginLeft: '8px' }}>
                  {response?.transaction_type?.application_source_name || 'N/A'}
                </strong>
              </Typography>
            ) : (response?.purchase?.lead_landing === undefined &&
                response?.payment_provider === null) ||
              response?.purchase?.lead_landing === 'Gift' ? (
              <Typography variant='body1' color='#FF6347' style={{ lineHeight: '2' }}>
                <strong>Flujo:</strong>
                <strong style={{ marginLeft: '8px' }}>{response?.purchase?.lead_landing}</strong>
              </Typography>
            ) : null}
            {response?.payment_provider !== null &&
            response?.purchase?.lead_landing !== undefined ? (
              <Typography variant='body1' color='#FF6347' style={{ lineHeight: '3' }}>
                <strong>Flujo:</strong>
                <strong style={{ marginLeft: '8px' }}>{response?.purchase?.lead_landing}</strong>
              </Typography>
            ) : null}
          </Grid>
          {canViewDetails && (
            <Grid item>
              <Button
                color='primary'
                onClick={handleViewDetails}
                style={{
                  backgroundColor: '#ede7f6',
                  color: '#6a1b9a',
                  textTransform: 'none',
                }}
              >
                Ver Detalle
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default TransactionCardSummary;
